var chunkToChildrenMap = {
	"199": [
		581
	],
	"616": [
		569
	],
	"625": [
		664,
		351
	],
	"642": [
		295
	],
	"744": [
		953,
		799
	],
	"917": [
		205
	],
	"984": [
		953
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));